/**
 * Converts a Blob to ArrayBuffer
 *
 * @param blob - The blob to convert
 * @returns Promise that resolves to the ArrayBuffer representation of the blob
 */
async function getArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
  return await blob.arrayBuffer();
}

/**
 * Decodes a Blob to text using TextDecoder
 *
 * @param blob - The blob to decode
 * @returns Promise that resolves to the decoded text string
 */
export async function decodeText(blob: Blob): Promise<string> {
  const decoder = new TextDecoder();
  const buffer = await getArrayBuffer(blob);
  return decoder.decode(buffer);
}
